export default "__VITE_ASSET__BoMmv5Hk__"